import { httpClient } from "@sazka/utils/http-clients/http-client";
import { Lottery } from "@sazka/lotteries/js/models/lottery";

interface LotteryCountdownResponse {
    remainingSeconds: number;
}

interface LotteryRemainingTime {
    lottery: Lottery;
    remainingSeconds: number;
}

export async function getDrawTimeBulk(lotteries: Lottery[]): Promise<LotteryRemainingTime[]> {
    const url = "/api/draw-info/countdown";
    const params = {
        gameNames: lotteries.join(","),
        v: new Date().getTime(),
    };

    try {
        const response = await httpClient.get<LotteryCountdownResponse[]>(url, {
            params,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            headers: { "Cache-Control": "no-store" },
        });

        return response.data.map((x, i) => {
            return {
                lottery: lotteries[i],
                remainingSeconds: x.remainingSeconds,
            };
        });
    } catch (err) {
        console.error("Error while requesting countdown time:", err);

        return lotteries.map((x) => {
            return {
                lottery: x,
                remainingSeconds: 0,
            };
        });
    }
}

export async function getDrawTime(lottery: Lottery): Promise<LotteryRemainingTime> {
    const url = `/api/draw-info/countdown/${lottery}`;

    const params = {
        v: new Date().getTime(),
    };

    try {
        const response = await httpClient.get<LotteryCountdownResponse>(url, {
            params,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            headers: { "Cache-Control": "no-store" },
        });

        return {
            lottery,
            remainingSeconds: response.data.remainingSeconds,
        };
    } catch (err) {
        console.error("Error while requesting countdown time:", err);

        return {
            lottery,
            remainingSeconds: 0,
        };
    }
}
